import React, { useState } from "react";
import { parseLocalStorage } from "./utils";
import { useAuth } from "./useAuth";
import { EmailLoginForm } from "./EmailLoginForm";
import SignUpPage from "./SignUpPage";
import "./LoginPage.css";

const LoginPage = () => {
  const [showSignUp, setShowSignUp] = useState(false);
  const [isEmailLogin, setIsEmailLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { loginWithGoogle, loginWithEmail, isLoading, error } = useAuth();

  const handleGoogleLogin = async () => {
    try {
      const storedVariables = parseLocalStorage();
      await loginWithGoogle(storedVariables);
    } catch (error) {
      // Error is handled by useAuth hook
    }
  };

  const handleEmailLogin = async (formData) => {
    try {
      const storedVariables = parseLocalStorage();
      await loginWithEmail(formData.email, formData.password, storedVariables);
    } catch (error) {
      // Error is handled by useAuth hook
    }
  };

  const handleContinue = () => {
    if (email) {
      setIsEmailLogin(true);
    }
  };

  if (showSignUp) {
    return <SignUpPage />;
  }

  return (
    <div className="min-h-screen">
      <div className="max-w-md items-center justify-center">
        <h1 className="text-[#1563FF] uppercase">HEALTHITRACK</h1>

        <h1 className="text-3xl">
          {isEmailLogin
            ? "Welcome back"
            : "Now let's find which treatments you're eligible for"}
        </h1>
        <p className="text-gray-600">
          {isEmailLogin
            ? "Enter your password to continue"
            : "First, you'll need an account with us."}
        </p>

        {isLoading && <div className="loading">Loading...</div>}

        {!isEmailLogin ? (
          <>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="input"
            />

            <button
              onClick={handleContinue}
              disabled={isLoading || !email}
              className="primary-button"
            >
              Continue
            </button>

            <div className="divider">
              <span>or</span>
            </div>

            <button
              onClick={handleGoogleLogin}
              disabled={isLoading}
              className="social-button"
            >
              <img src="/google.png" alt="Google logo" />
              Continue with Google
            </button>

            <div className="text-center">
              <p>
                Already have an account?{" "}
                <button
                  onClick={() => setShowSignUp(true)}
                  className="link-button"
                >
                  Sign in
                </button>
              </p>
            </div>

            <div className="privacy-notice">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>
                HealthiTrack takes your privacy seriously with industry leading
                encryption.
              </span>
            </div>
          </>
        ) : (
          <>
            {error && (
              <div className="error-message">
                {error || "An error occurred. Please try again."}
              </div>
            )}

            <input type="email" value={email} disabled className="input " />

            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="input mt-2"
              />
              <button
                type="button"
                className={`password-toggle ${showPassword ? "active" : ""}`}
                onClick={() => setShowPassword(!showPassword)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>

            <button
              onClick={() => handleEmailLogin({ email, password })}
              disabled={isLoading}
              className="primary-button"
            >
              Sign in
            </button>

            <button
              onClick={() => setIsEmailLogin(false)}
              className="back-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              Back
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
